import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	selector: 'app-mes-cjs',
	templateUrl: './mes-cjs.component.html',
	styleUrls: ['./mes-cjs.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class MesCjsComponent {}
